export default "__VITE_ASSET__MFdVU$3Z9gwG34EV6W5zBQ__"